//nuitaLHotel.js

import React from 'react';
import Particles from 'react-particles';
//import {loadFull} from 'tsparticles';
import { useCallback } from 'react';
import { loadSlim } from "tsparticles-slim";
import './projet.css';

function Simon() {
    

      const particlesInit = useCallback(async engine => {
        console.log(engine);
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        //await loadFull(engine);
        await loadSlim(engine);
      }, []);
  
      const particlesLoaded = useCallback(async container => {
          await console.log(container);
      }, []);

      return (
      <div className='flex'>
        <a href="/" className='back'>Back to Main Page</a>
        <h1>Simon3</h1>
        <p className='center'><i>Develop with Unreal Engine 5.3</i></p>
    
        <iframe width="560" height="315" title='Introduction Video' src="https://www.youtube.com/embed/XC1fnxggQPo"  allowFullScreen></iframe>
        <div className='download'><a href="https://fl3ur.itch.io/simon3" className='itchio'>Play the game on Itch.io</a></div>
        

      <div className="paragraph-container">
        <h3>Game Overview</h3>
        <p>Passionate about rhythm and memory games? Then Simon3 is made for you. Find the combinations of colors displayed in front of you, to the rhythm of your chosen music, increasing the difficulty and taking on ever more challenging challenges.</p>

        <h3>Gameplay</h3>
        <p>With a light-up cube akin to a Rubik's Cube, the player must replicate the displayed color combinations to the rhythm of the music.</p>

        <div className="columns">
        <div className="column">
            <h4>Developers</h4>
            <ul>
                <li>Antoine Yebouet</li>
                <li>François Dénès</li>
                <li>Thibault Boisseau</li>
            </ul>
        </div>

        <div className="column">
            <h4>Sound Designer</h4>
            Antoine Yebouet
        </div>

        <div className="column">
            <h4>Supervisor</h4>
            Sylvain Boivin, Ph. D.
        </div>
        </div>
        </div>
        <div className='particles-container'>
      <Particles 
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
            background: {
                color: {
                    value: "#0d47a1",
                },
            },
            fpsLimit: 120,
            interactivity: {
                events: {
                    onClick: {
                        enable: true,
                        mode: "push",
                    },
                    onHover: {
                        enable: true,
                        mode: "repulse",
                    },
                    resize: true,
                },
                modes: {
                    push: {
                        quantity: 4,
                    },
                    repulse: {
                        distance: 200,
                        duration: 0.4,
                    },
                },
            },
            particles: {
                color: {
                    value: "#ffffff",
                },
                links: {
                    color: "#ffffff",
                    distance: 150,
                    enable: true,
                    opacity: 0.5,
                    width: 1,
                },
                move: {
                    direction: "none",
                    enable: true,
                    outModes: {
                        default: "bounce",
                    },
                    random: false,
                    speed: 6,
                    straight: false,
                },
                number: {
                    density: {
                        enable: true,
                        area: 800,
                    },
                    value: 80,
                },
                opacity: {
                    value: 0.5,
                },
                shape: {
                    type: "circle",
                },
                size: {
                    value: { min: 1, max: 5 },
                },
            },
            detectRetina: true,
        }}
      />
      </div>
    </div>
    );
  }
  
  export default Simon;
